import React from 'react'
import { GeoAlt, Search } from 'react-bootstrap-icons'
import ResultItem from './ResultItem'
import IconCondition from '../IconCondition'
import IconLanguage from '../IconLanguage'
import IconActivities from '../IconActivities'
import IconAmenities from '../IconAmenities'
import IconSetting from '../IconSetting'
import IconApproach from '../IconApproach'
import IconSpecialConsiderations from '../IconSpecialConsiderations'
import IconClientele from '../IconClientele'
import IconTherapies from '../IconTherapies'
import IconTreatmentServices from '../IconTreatmentServices'
import IconInsurance from '../IconInsurance'
import { isNonEmptyString } from '@/utils/checks'
import IconCenterPlaceholder from '../icons/iconCenterPlaceholder'
import IconVerifiedCheckMark from '../IconVerifiedCheckMark'
const iconClass = 'min-w-6 min-h-6 stroke-gray-1100'

const Icon = ({ type }) => {
  switch (type) {
    case 'footer':
      return <Search size={24} />
    case 'activities':
    case 'off_site_activities':
    case 'onsite_activities':
      return <IconActivities customCss={iconClass} />
    case 'amenities':
      return <IconAmenities customCss={iconClass} />
    case 'treatment_therapies':
      return <IconTherapies customCss={iconClass} />
    case 'accepted_insurance':
      return <IconInsurance customCss={iconClass} />
    case 'treatment_methods':
      return <IconApproach customCss={iconClass} />
    case 'who_we_treat':
      return <IconClientele customCss={iconClass} />
    case 'languages':
      return <IconLanguage customCss={iconClass} />
    case 'what_we_treat':
      return <IconCondition customCss={iconClass} />
    case 'setting':
      return <IconSetting customCss={iconClass} />
    case 'special_considerations':
      return <IconSpecialConsiderations customCss={iconClass} />
    case 'treatment_services':
      return <IconTreatmentServices customCss={iconClass} />
    case 'center':
      return <></>
    default:
      return <GeoAlt size={24} />
  }
}

const AutoCompleteResultItem = ({ result, className }) => {
  // There are some cases where Algolia will match something like America, and return it as title.
  // In other cases Algolia can match North America and return it as formattedAddress. Google results always return formatted address.
  const htmlToInsert =
    result?._highlightResult?.formattedAddress?.value ||
    result?._highlightResult?.title?.value ||
    result?._highlightResult?.label?.value

  const centerHtmlToInsert = (
    <span
      className="higlighted-text line-clamp-2 leading-5 text-[16px] text-gray-1100"
      aria-label={result.title}
    >
      <span
        dangerouslySetInnerHTML={{
          __html: result?._highlightResult?.title?.value
        }}
      />
    </span>
  )
  const isCenterResult = result.type === 'center'
  const isNotLocation = result.type != 'location'

  return (
    <ResultItem className={`${className} group`}>
      <div className="min-h-8 min-w-8 flex items-center justify-center">
        {isCenterResult && isNonEmptyString(result.featured_image) && (
          <img
            src={result.featured_image}
            alt={result.title}
            className="object-cover size-8 rounded-md"
            aria-label={result.title}
          />
        )}
        {isCenterResult && !isNonEmptyString(result.featured_image) && (
          <IconCenterPlaceholder
            className={`bg-gray-300 group-hover:bg-primary-150 group-active:bg-fill-150 group-focus:fill-primary-150 group-active:stroke-primary-150 group-focus:stroke-primary-400 rounded-md`}
          />
        )}
        {!isCenterResult && <Icon type={result.type} />}
      </div>
      <div className="flex flex-col pl-4">
        {isCenterResult && centerHtmlToInsert}
        {!isCenterResult && (
          <span
            className={`higlighted-text line-clamp-2 leading-5 text-[16px] text-gray-1100`}
            dangerouslySetInnerHTML={{
              __html: htmlToInsert
            }}
            aria-label={result.title}
          />
        )}
        {result.title && isNotLocation && !isCenterResult && (
          <span className="text-sm font-normal text-gray-800">
            {result.title}
          </span>
        )}
        {isCenterResult && (
          <span className="text-sm font-normal text-gray-800 line-clamp-1">
            {result.location_label}{' '}
          </span>
        )}
      </div>
    </ResultItem>
  )
}
export default AutoCompleteResultItem
